/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import BorderLoader from "components/atoms/loader/BorderLoader";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

type Props = {
  THEOPlayerElementHeight: number;
  isDarkModeEnabled: boolean;
  cartTotalFee: number;
  shippingFee: number;
  settlementFee: number;
  totalFee: number;
  isCalculatingShippingFee: boolean;
};

export const StreamingLiveCommerceAmountV2: React.FC<Props> = (props) => {
  const { t } = useI18n();
  const classesLiveCommerceCartAmountDesign = liveCommerceCartAmountDesign({
    THEOPlayerElementHeight: props.THEOPlayerElementHeight,
    isDarkModeEnabled: props.isDarkModeEnabled,
  });

  return (
    <div css={classesLiveCommerceCartAmountDesign.paymentAmount}>
      <div css={classesLiveCommerceCartAmountDesign.shippingFee}>
        <p>{t("streaming.commerceCart.productTotal")}</p>
        <p>¥{props.cartTotalFee.toLocaleString()}</p>
      </div>
      <div css={classesLiveCommerceCartAmountDesign.shippingFee}>
        <p>{t("streaming.commerceCart.shippingFee")}</p>
        {props.isCalculatingShippingFee ? (
          <BorderLoader height="20px" width="40px" />
        ) : (
          <p>¥{props.shippingFee.toLocaleString()}</p>
        )}
      </div>

      <div css={classesLiveCommerceCartAmountDesign.settlementFee}>
        <p>{t("streaming.commerceCart.settlementFee")}</p>
        <p>¥{props.settlementFee.toLocaleString()}</p>
      </div>

      <div css={classesLiveCommerceCartAmountDesign.total}>
        <p>{t("streaming.commerceCart.total")}</p>
        <p>¥{props.totalFee.toLocaleString()}</p>
      </div>
    </div>
  );
};

type LiveCommerceCartDesignProps = {
  THEOPlayerElementHeight: number;
  isDarkModeEnabled: boolean;
};

const liveCommerceCartAmountDesign = (props: LiveCommerceCartDesignProps) => {
  const textColorInDarkMode = props.isDarkModeEnabled
    ? css`
        color: #fff;
      `
    : null;
  const paymentAmount = css`
    padding: 16px 0;
    margin-bottom: 16px;
  `;
  const shippingFee = css`
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    ${textColorInDarkMode}
    font-size: 15px;
  `;
  const settlementFee = css`
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    margin-bottom: 16px;
    ${textColorInDarkMode}
    font-size: 15px;
    border-bottom: 1px solid #e0e0e0;
  `;
  const total = css`
    display: flex;
    justify-content: space-between;
    ${textColorInDarkMode}
    font-size: 15px;
  `;
  return {
    paymentAmount,
    shippingFee,
    settlementFee,
    total,
  };
};
